"use client";

import { useState } from "react";
import { trackFaqToggle } from "./ga-events";
import { ChevronDown } from "lucide-react";

interface FaqItem {
  q: string;
  a: string;
}

export function TrackedFaq({
  items,
  mobileLimit = 0,
  defaultLimit = 6,
}: {
  items: FaqItem[];
  mobileLimit?: number;
  defaultLimit?: number;
}) {
  const [showAll, setShowAll] = useState(false);
  const hasDefaultLimit = defaultLimit > 0 && defaultLimit < items.length;

  return (
    <div className="mt-12 space-y-4">
      {items.map((item, i) => {
        const hiddenOnMobile = mobileLimit > 0 && i >= mobileLimit && !showAll;
        const hiddenByDefault = hasDefaultLimit && i >= defaultLimit && !showAll;

        return (
          <details
            key={item.q}
            className={`group overflow-hidden rounded-2xl border border-white/5 bg-white/[0.02] transition-colors duration-300 hover:border-blue-500/15${hiddenByDefault ? "hidden" : hiddenOnMobile ? "hidden md:block" : ""}`}
            onToggle={(e) => {
              if ((e.target as HTMLDetailsElement).open) {
                trackFaqToggle(item.q);
              }
            }}
          >
            <summary className="flex cursor-pointer items-center justify-between px-6 py-5 text-left font-semibold transition-colors hover:text-blue-400 [&::-webkit-details-marker]:hidden">
              {item.q}
              <ChevronDown
                className="ml-4 h-5 w-5 shrink-0 text-gray-500 transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-open:rotate-180 group-open:text-blue-400"
                aria-hidden="true"
              />
            </summary>
            <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-open:grid-rows-[1fr]">
              <div className="overflow-hidden">
                <div className="px-6 pb-5 text-sm leading-relaxed text-gray-300">{item.a}</div>
              </div>
            </div>
          </details>
        );
      })}
      {hasDefaultLimit && !showAll && (
        <button
          onClick={() => setShowAll(true)}
          className="w-full py-3 text-sm font-medium text-blue-400 transition-colors hover:text-blue-300"
        >
          Bekijk alle {items.length} vragen &darr;
        </button>
      )}
    </div>
  );
}
